export interface BankerEntity {

    id: number,
    bankCode: string,
    bankName?: string | null,
    bankAcNo?: string | null,
    bankAcCurrency?: string | null,
    bankContactPerson?: string | null,
    contactNo?: string | null,
    bankAddressLine1?: string | null,
    bankAddressLine2?: string | null,
    bankAddressLine3?: string | null,
    bankAddressLine4?: string | null,
    bankAddressLine5?: string | null,
    activeInd?: string | null,
    createdBy?: string | null,
    createdDateTime?: Date | null,
    updatedBy?: string | null,
    updatedDateTime?: Date | null,

    [key: string]: string | boolean | number | null | Object | undefined
}

export const EMPTY_BANKER_ENTITY: BankerEntity = {
    id: 0,
    bankCode: '',
    bankName: null,
    bankAcNo: null,
    bankAcCurrency: null,
    bankContactPerson: null,
    contactNo: null,
    bankAddressLine1: null,
    bankAddressLine2: null,
    bankAddressLine3: null,
    bankAddressLine4: null,
    bankAddressLine5: null,
    activeInd: 'N',
    createdBy: null,
    createdDateTime: null,
    updatedBy: null,
    updatedDateTime: null,
}
